/**
 * Created by mimadmin on 4/19/2017.
 */
export class DisplayAttribute {
  Name: string;
  DisplayName: string;
  Description: string;
  Caption: string;
  DataType: string;
  Multivalued: boolean;
  StringRegex: string;
  AttributeID: string;
  ObjectID: string;
  FileName: string;

  static getProperty(da: DisplayAttribute, name: string): any {
    switch (name.toLowerCase()) {
      case 'name':
        return da.Name;
      case 'displayname':
        return da.DisplayName;
      case 'description':
        return da.Description;
      case 'caption':
        return da.Caption;
      case 'datatype':
        return da.DataType;
      case 'multivalued':
        return da.Multivalued;
      case 'stringregex':
        return da.StringRegex;
      case 'attributeid':
        return da.AttributeID;
      case 'objectid':
        return da.ObjectID;
      case 'filename':
        return da.FileName;
      default:
        return null;
    }
  }

  static getDefaultAttribute(name: string): DisplayAttribute {
    return <DisplayAttribute>{
      Name: name,
      DisplayName: name,
      Description: name,
      Caption: name,
      DataType: 'String',
      Multivalued: false,
      StringRegex: '',
      FileName: '',
    };
  }

  static getLocalAttribute(name: string): DisplayAttribute {
    return <DisplayAttribute>{
      Name: name,
      DataType: null,
      ObjectID: null,
    };
  }
}
